<template>
    <div :class="phoneClass || 'login-container'">
        <div class="login-header">
            <index-header>
                <div class="slot-content">
                    {{$t('header.login')}}
                </div>
            </index-header>
        </div>
        <div class="login-content">
            <div class="content-form" @keyup.enter="login">
                <h2 class="title">{{$t('header.login')}}</h2>
                <div class="input-area">
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.email')}}</p>
                        <el-input v-model="loginForm.account" :placeholder="$t('loginPage.email')"></el-input>
                    </div>
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.password')}}</p>
                        <el-input v-model="loginForm.password" type="password" :placeholder="$t('loginPage.password')"></el-input>
                    </div>
                </div>
                <el-button type="primary" class="login-button" @click="login">{{$t('header.login')}}</el-button>
                <div class="operation">
                    <p @click="goRegister(1)">{{$t('loginPage.create_new_account')}}</p>
                    <p style="margin-bottom: 5px" @click="goRegister(0)">{{$t('loginPage.forget_password')}}？</p>
                    <div class="operation-floor" v-if="false">
                        <el-button @click="goRegister(1)">{{$t('loginPage.oem_customer')}}1</el-button>
                        <el-button @click="goRegister(2)">{{$t('loginPage.afm_customer')}}2</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import IndexHeader from './layout/header'
import Core from "core/core";
import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
	        loginForm: {
                account: '',
                password: ''
            },
        };
    },
    components: {
        IndexHeader
    },
    mounted(){
        console.log('query', this.$route.query);
    },
    created() {
	    refresh(this,'phoneClass-login');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-login');
		    },10)
	    };

	    // window.localStorage.clear();
        // if(!Core.Data.isGuest()) {
        //     this.$router.push('/home');
        // }
    },
    computed: {
    },
    methods: {
        login() {
            let login = this.loginForm;
            Core.Api.User.loginByEmail(login.account,login.password)
            .then(res => {
                // this.$message.success('登录成功');
                this.loginSuccess(res)
            })
        },

        loginSuccess(res) {
            let { user, token } = res;
            Core.Data.setToken(token);
            Core.Data.setUser(user);
            // role：2工厂
            user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
            // user.role === 1 ? this.$router.push('/home') : user.role === 2 ? this.$router.push('/storage') : this.$router.push('/home');
        },
        goRegister(i) {
            i ? this.$router.push(`/register?type=${i}`) : this.$router.push("/retrieve")
        }
    },


};
</script>

<style scoped lang="scss">
@import '../assets/style/mixin.scss';
.login-container {
    height: 100vh;
    width: 100%;
    background: #E5EBEF;
    // background-image: radial-gradient(ellipse farthest-corner at 50% 100%, #263B4E 0%, #1A2936 100%);
    position: relative;
    // padding-top: 1px;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba($color: #000000, $alpha: .3);
            display: inline-block;
            vertical-align: middle;
            font-size: 20px;
            color: #99BEFF;
            
            line-height: 26px;
            padding-left: 20px;
            font-weight: 500;
        }
    }
    .login-content {
        position: relative;
        height: 500px !important;
        background-color: #E5EBEF;
        .content-form {
            width: 430px;
            position: absolute;
            background-color: #ffffff;
            padding: 40px;
            top: 51.2%;
            left: 50%;
            transform: translate(-50%,-50%);
            .title {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }
            .input-area {
                margin-top: 30px;
                margin-bottom: 40px;
                .input-floor {
                    margin-bottom: 20px;
                    .key {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 6px;;
                    }
                }
            }
            .login-button {
                width: 100%;
                height: 46px;
                span {
                    font-size: 16px;
                }
                color: #FFFFFF;
            }
            .operation {
                margin-top: 25px;
                p {
                    margin-bottom: 14px;
                    text-align: center;
                    font-size: 14px;
                    color: #0F58D6;
                    font-weight: 500;
                    cursor: pointer;
                }
                .operation-floor {
                    .el-button {
                        span {
                            font-size: 14px;
                            color: #0F58D6;
                            line-height: 20px;
                            padding: 10px 19px;
                        }
                    }
                }
            }
        }
    }
}

</style>

<style lang="scss">

.login-container {
    height: 100vh;
    background: #E5EBEF;
    .login-content{
        height: 500px !important;
        .content-form {
            top: 50%;
        }

        .input-floor {
            .el-input {
                height: 46px;
                .el-input__inner {
                    height: 46px;;
                }
            }
        }
    }
    .operation-floor {
        .el-button {
            span {
                font-size: 14px;
                color: #0F58D6;
                line-height: 20px;
                padding: 4px 3px;
                display: inline-block;
            }
        }
    }
}
.phoneClass-login {
    .el-button {
        width: 100%;
    }
    .el-input__inner {
        height: 30px;
    }
}
.phoneClass-login {
    min-height: 100vh;
    background: #E5EBEF;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba(0, 0, 0, 0.3);
            color:#99BEFF;
            padding-left: 0.2rem;
            font-size: 0.3rem;
            vertical-align: middle;
            font-weight: 500;
        }
    }
    .login-content {
        width: 100%;
        .content-form {
            width: 70%;
            margin: 30px auto;
            background: white;
            padding: 30px;
            h2 {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }

            .input-area {
                margin-top: 15px;
                margin-bottom: 15px;
                .input-floor{
                    margin-bottom: 20px;
                    p {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 6px;
                    }
                    .el-input {

                        .el-input__inner {
                            height: 40px;
                        }
                    }
                }
            }
        }
        .operation {
            margin-top: 15px;
            text-align: center;
            font-size: 12px;
            color: #0F58D6;
            font-weight: 500;
            cursor: pointer;
            p {
                margin-bottom: 5px;
            }
        }
    }
}
</style>
